<template>
  <div>
   
    <v-expansion-panel inset>
      <v-expansion-panel-content
        v-for="(item,i) in items"
        :key="i"
        v-if="!item.hideS"
        v-model="expandMain"
      >
        <div slot="header">
          {{secToClock(item.time)}}
          <v-icon>{{getIcon(item.type)}}</v-icon>
          &nbsp;&nbsp;{{item.title}}{{item.name}}&nbsp;{{getArtist(item.id)}}
        </div>

        <v-card>
          <v-layout v-if="item.type!='playlist'" row>
            <div style="width:180px;padding:20px;padding-top:0px;">
              <v-img width="160" :src="getContent(item.id).imageUrl"></v-img>
            </div>
            <v-flex>
              <v-card-text v-if="item.type!='playlist'" style="padding-top:0px">
                Title: {{item.title}}
                <br />
                Artist: {{getContent(item.id).artist}}
                <br />
                Description: {{getContent(item.id).description}}
                <br />
                Duration: {{secondsToDurationText(item.duration)}}
                <br />
              </v-card-text>
            </v-flex>
          </v-layout>
          <v-card-text v-if="item.type=='playlist'" style="padding-top:0px">
            <v-expansion-panel inset v-model="expandSubX" expand>
              <v-expansion-panel-content
                v-for="child in playlists[item.id].items"
                v-if="getContent(child.id).type!='title' && !getContent(child.id).hideS"
              >
                <div slot="header">
                  {{secToClock(child.time)}}&nbsp;&nbsp;
                  <v-icon>{{getIcon(getContent(child.id).type)}}</v-icon>
                  &nbsp;
                  {{ getContent(child.id).title}}&nbsp;-&nbsp;{{ getContent(child.id).artist}}
                </div>
                <v-card>
                  <v-layout>
                    <div style="width:180px;padding:20px;padding-top:0px;">
                      <v-img height="140" width="160" :src="getContent(child.id).imageUrl"></v-img>
                    </div>
                    <v-flex>
                      <v-card-text style="padding-top:0px">
                        Title:{{getContent(child.id).title}}
                        <br />
                        Artist:{{getContent(child.id).artist}}
                        <br />
                        Description:{{getContent(child.id).description}}
                        <br />
                        Duration:{{secondsToDurationText(child.duration)}}
                      </v-card-text>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>
<script>
export default {
  props: ["schedule"],
  data() {
    return {
      items: [],
      playlists: {},
      expandSub: [],
      expandMain: false
    };
  },
  watch: {
    schedule(value) {
      console.log("XXXXX Watch", this.schedule);
      this.fillSchedule();
    },
    expandPlaylist(value) {
      if (value) {
        this.expandMain = [true];
      } else {
        this.expandMain = false;
      }
    }
  },
  mounted: function() {
    console.log("XXXXX Mounted View", this.schedule);
    if (this.schedule) {
      this.fillSchedule();
      if (this.schedule.expandPlaylist) {
        this.expandMain = [true];
      } else {
        this.expandMain = false;
      }
    }
    this.$store.dispatch("loadMenuItems");
  },
  computed: {
    expandPlaylist() {
      console.log("expandPlaylist WATCHER")
      if(this.schedule){
        return this.schedule.expandPlaylist;
      }else{
        return false
      }
      
    }
  },
  methods: {
    getArtist(id) {
      var cont = this.getContent(id);
      if (!cont) {
        return null;
      }
      return "- " + cont.artist;
    },
    getIcon(type) {
      var icon = null;
      switch (type) {
        case "video":
          icon = "ondemand_video";
          break;
        case "title":
          icon = "title";
          break;
        case "playlist":
          icon = "list";
          break;
        case "web":
          icon = "web_asset";
          break;
      }
      return icon;
    },
    fillSchedule() {
      console.log("FILL Schedule")
      var id;
      var pIndex;
      var time = this.clockToSec(this.schedule.startTime);
      var playlist;
      console.log("this.schedule", this.schedule);
      var item;
      for (var i in this.schedule.items) {
        item = this.schedule.items[i];
        console.log("item", item);
        if (item.pListId) {
          console.log("NEW PLAYLIST", item.pListIndex);
          id = item.pListId;
          pIndex = id;
          console.log("a playlist starting at ", item, time);
          item.time = time

          console.log("Playlist", id, pIndex, item);
          if (this.playlists[pIndex]) {
            console.log("------", item);
            this.playlists[pIndex].items.push(item);
          } else {
            this.playlists[pIndex] = {
              items: [item],
              ppIndex: item.pListIndex
            };
            playlist = this.$store.getters.loadedPlaylist(id);
            console.log("Playlist  ", playlist, id);
            playlist.time = time;
            //for(var p in playlist.items){
            // console.log("XXXXX",playlist.items)
            //playlist.items[p].duration=playlist.items[p].duration
            //playlist.items[p].duration=this.getContent(playlist.items[p].id).duration*playlist.items[p].loops;
            //time+=playlist.items[p].duration

            //playlist.items[p].time=time
            //}
            this.items.push(playlist);
          }
          //time=time+this.getContent(item.id).duration*item.loops;
          time = time + item.duration*item.loops;
        } else {
          item.time = time;
          this.items.push(item);
          console.log("XXXXX", item);
          time += item.duration * item.loops;
          console.log("XXXXX Time", time);
        }
      }
      console.log("******", this.playlists);
      console.log("******---", this.items);
    },

    getContent(id) {
      return this.$store.getters.loadedContent(id);
    },
    secToTime(sec) {
      var secs = sec % 60;
      var mins = ((sec - secs) / 60) % 60;
      var hrs = (sec - mins * 60 - secs) / 60 / 60;
      secs = Math.round(secs);
      if (secs < 10) secs = "0" + secs;
      if (mins < 10) mins = "0" + mins;
      return hrs + ":" + mins + ":" + secs;
    },
    timeToSec(time) {
      var times = time.split(":");
      var secs = parseInt(times[2], 10);
      var mins = parseInt(times[1], 10);
      var hrs = parseInt(times[0], 10);

      return hrs * 60 * 60 + mins * 60 + secs;
    },
    clockToSec(time) {
      var times = time.split(":");
      var mins = parseInt(times[1], 10);
      var hrs = parseInt(times[0], 10);

      return hrs * 60 * 60 + mins * 60;
    },
    secToClock(sec) {
      if (this.schedule.hideTime) {
        return;
      }
      var secs = sec % 60;
      var mins = ((sec - secs) / 60) % 60;
      var hrs = (sec - mins * 60 - secs) / 60 / 60;
      if (this.isWeekend()) {
        hrs += 2;
      }
      secs = Math.round(secs);
      if (secs < 10) secs = "0" + secs;
      if (mins < 10) mins = "0" + mins;
      return hrs + ":" + mins;
      //return hrs+":"+mins+":"+secs
    },
    isWeekend() {
      var day = new Date().getDay();
      return day == 6 || day == 0;
    },
    secondsToDurationText(sec) {
      var hrs = Math.floor(sec / (60 * 60));
      var mins = Math.floor((sec - hrs * 60 * 60) / 60);
      var secs = Math.floor(sec % 60);
      var time = "";
      if (hrs > 0) {
        time = hrs + "hour" + this.plural(hrs) + " ";
      }
      if (mins > 0) {
        time = time + mins + "min" + this.plural(mins) + " ";
      }
      if (secs > 0) {
        time = time + secs + "sec" + this.plural(secs) + " ";
      }
      return time;
    },
    plural(val) {
      if (val != 1) {
        return "s";
      } else {
        return "";
      }
    }
  }
};
</script>
<style>
.programItem {
  padding: 5px;
  width: 100%;
  overflow: hidden;
  background-color: #eeeeee;
}
.programItem .selected {
  background-color: #ddd;
}
.moreInfo {
  min-height: 120px;
  background-color: #f3f3f3;
}
.programItem:nth-child(odd) {
  background: #f3f3f3;
}
</style>



// WEBPACK FOOTER //
// src/components/Content/ScheduleView.vue